/* Popup */
function initTestimonialPopup() {

  /* ===============================
     OPEN POPUP & PLAY VIDEO
  =============================== */
  document.querySelectorAll(".testimonial_open").forEach(el => {
    el.addEventListener("click", function () {
      const popup = document.querySelector(".testimonial_popup");
      const video = popup.querySelector("video");

      // Show popup
      popup.classList.add("open");
      document.body.classList.add("testimonial_overlay_is_open");

      // Load video source only once
      const videoURL = video.getAttribute("video_url");
      if (!video.getAttribute("src")) {
        video.setAttribute("src", videoURL);
      }

      video.play();
    });
  });
  
  /* ===============================
     CLOSE POPUP (BUTTON & OVERLAY)
  =============================== */
  document.querySelectorAll(".testimonial_close").forEach(el => {
    el.addEventListener("click", closePopup);
  });

  document.querySelectorAll(".testimonial_overlay").forEach(el => {
    el.addEventListener("click", closePopup);
  });

  function closePopup() {

    // Hide popups & overlay
    document.querySelectorAll(".testimonial_popup").forEach(popup => {
      popup.classList.remove("open");
    });

    document.body.classList.remove("testimonial_overlay_is_open");

    // Pause ALL videos in .video_play_list_new
    document.querySelectorAll(".testimonial_popup video").forEach(video => {
      video.pause();
      //video.currentTime = 0; // reset (optional)
    });
  }
}

initTestimonialPopup();
/* Popup */

/* Mobile Drawer */
const target = document.querySelector('.Template_side_mainitem_new');
const toggleElement = document.querySelector('.project_overview_mobile_new');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      // Element is NOT visible
      toggleElement.classList.add('active');
      document.body.classList.add("top_part_is_set");
    } else {
      // Element is visible again
      toggleElement.classList.remove('active');
      document.body.classList.remove("top_part_is_set");
    }
  });
}, {
  threshold: 0 // triggers as soon as it leaves/enters viewport
});

if (target) {
  observer.observe(target);
}

/* Height Calculate */
const parent = document.querySelector('.Template_side_mainitem_new');
const inner = document.querySelector('.Template_side_inneritem_new');

if (parent && inner) {
  let lastHeight = 0;

  const updateHeight = () => {
    const height = inner.offsetHeight;

    // ✅ ignore 0 height
    if (height === 0) return;

    // ✅ update only if changed
    if (height !== lastHeight) {
      lastHeight = height;
      parent.style.minHeight = height + 'px';
    }
  };

  // Observe inner (NOT parent)
  const resizeObserver = new ResizeObserver(() => {
    setTimeout(updateHeight, 50); // helps with accordion animation
  });

  resizeObserver.observe(inner);

  // Initial run
  window.addEventListener('load', updateHeight);
  window.addEventListener("resize", debounce(updateHeight, 150));

  // Optional: if accordion triggers via click
  document.addEventListener('click', () => {
    setTimeout(updateHeight, 300);
  });
}

/* Mobile drawer */
document.querySelector('.project_overview_mobile_new')?.addEventListener('click', () => {
  document.querySelector('.Template_side_inneritem_new')?.classList.add('open');
  document.body.classList.add("top_part_is_set_open");
});

document.querySelector('.top_part_is_set_open_overlay')?.addEventListener('click', () => {
  document.querySelector('.Template_side_inneritem_new')?.classList.remove('open');
  document.body.classList.remove("top_part_is_set_open");
});

document.querySelector('.Template_side_inneritem_mobile_top_close_new')?.addEventListener('click', () => {
  document.querySelector('.Template_side_inneritem_new')?.classList.remove('open');
  document.body.classList.remove("top_part_is_set_open");
});


/* Template_partner_logo_marquee */
initMarquee('.Template_partner_logo_marquee', {
    mobile: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});
/* Template_partner_logo_marquee */